module.exports = __webpack_public_path__ + "static/img/Aions_Mar_3.3697bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_3.png
// module id = ugU7
// module chunks = 19